import React, { useEffect } from 'react';
import styles from './RoadsideReimagined.module.scss'; // Ensure this points to your module SCSS file
import { useInView } from 'react-intersection-observer'; // Assuming it's already installed
import Picture from '../../images/WorkInProgress.png';
import { Analytics } from '@vercel/analytics/react';


const RoadsideReimagined: React.FC = () => {
  const [infoRef, infoInView] = useInView({ triggerOnce: true, threshold: 0.1 });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.projectPage}>
      
      <Analytics/>

      <div className={styles.contentContainer}>
        <h1>Roadside Assistance Reimagined</h1>
        <div ref={infoRef} className={`${styles.infoSection} ${infoInView ? styles.fadeIn : ''}`}>
          <div className={styles.infoColumn}>
            <div className={styles.title}>CLIENT</div>
            <div className={styles.detail}>PitStop</div>
          </div>
          <div className={styles.infoColumn}>
            <div className={styles.title}>ROLE</div>
            <div className={styles.detail}>Technical Product Manager Intern</div>
          </div>
          <div className={styles.linkColumn}>
            <div className={styles.title}>LINK</div>
            <div className={styles.detail}>
              <a href="" target="_blank" rel="noopener noreferrer">
                projectLink-comingSoon.com
              </a>
            </div>
          </div>
        </div>
        <img src={Picture} alt="Construction" className={styles.image}/>
        <p className={styles.constructionFootnote}>
          HANG TIGHT! WE'RE COOKING UP SOMETHING AWESOME
          {/* <span className={styles.emoji}>
            <img 
              src="https://cdn3.emoji.gg/emojis/4233-chefskiss.png" 
              alt="Chef's Kiss Emoji" 
            />
          </span> */}
        </p>
      </div>
    </div>
  );
};

export default RoadsideReimagined;
